import { createAdminAccountSubmissionPreviews } from "./AdminAccountSubmissionPreviews";

export const AdminAccountSubmissionPreviewsOpen = createAdminAccountSubmissionPreviews(
	"admin_account_submissions_open",
	(account) =>
		!account.hasBeenActive && (account.status === "approved" || account.status === "review"),
);
